module.exports = __webpack_public_path__ + "img/LT112021238.0e41ec16.svg";